import { CheckMarkIcon } from './icons/CheckMarkIcon';
import React from 'preact/compat';

export const ValueProps: React.FC<{ props: string[] }> = ({ props }) => {
  return (
    <ul>
      {props.map((prop) => {
        return (
          <li className={'cart-drawer__value-prop'}>
            <CheckMarkIcon role={'presentation'} />
            {prop}
          </li>
        );
      })}
    </ul>
  );
};
